import { useCallback, useEffect } from 'react';
import { PrimitiveAtom, useAtomValue, useSetAtom } from 'jotai';
import queryString from 'query-string';
import { updateUrl } from '@/utils';
import { encodeVisibleIndexes, applyVisibilityByIndex } from './utils';

export type LabelClassesDeeplinkState = {
  shouldUpdateUrl: boolean;
  labelClassByIdAtom: PrimitiveAtom<{ [id: string]: { isVisible?: boolean } } | undefined>;
};

export const useLabelClassesDeeplink = (state: LabelClassesDeeplinkState) => {
  const { shouldUpdateUrl, labelClassByIdAtom } = state;

  const labelClassById = useAtomValue(labelClassByIdAtom);
  const setLabelClassById = useSetAtom(labelClassByIdAtom);

  useEffect(() => {
    if (shouldUpdateUrl) {
      updateUrl('visibleLabelClasses', encodeVisibleIndexes(labelClassById));
    }
  }, [shouldUpdateUrl, labelClassById]);

  const applyFromParsed = useCallback(
    (parsed: queryString.ParsedQuery<string>) => {
      if (parsed.visibleLabelClasses !== undefined) {
        setLabelClassById((current) => applyVisibilityByIndex(current, parsed.visibleLabelClasses));
      }
    },
    [setLabelClassById]
  );

  return { applyFromParsed };
};
